import React, { useState } from 'react';
import { useMount } from 'ahooks';
import { fetchGuideStatus } from '@intelligence/services/topcharts';
import { dbiBtnLogMes } from '@intelligence/utils/buriedPointCfg';
import { typeIdObj } from '@home/utils/buriedPoint';

/**
 * @description Top Charts榜单Active Users落地页提示交互
 * 1、首次进入表格时，游戏关注信息提示
 * 2、下载按钮气泡提示
 */
export default function useTopChartsActiveUsersNotifications() {
  // 是否展示首次进入表格时，游戏关注信息提示
  const [showFirstGuide, setShowFirstGuide] = useState(false);
  // 是否展示下载按钮气泡提示
  const [showFirstDownLoadBubble, setShowFirstDownLoadBubble] = useState(false);

  /**
   * @description 更新用户提示漫游状态
   * @param setter 是否展示提示的setter
   * @param params 接口入参
   */
  const updateGuideStatus = async (
    setter: React.Dispatch<React.SetStateAction<boolean>>,
    params: IGuideStatusFetchParams,
  ) => {
    try {
      const res = await fetchGuideStatus(params);
      if (res?.code === 0) {
        setter(!!res?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * @description 初始化
   */
  useMount(() => {
    /**
     * @description 更新首次进入表格时，游戏关注信息提示的漫游状态
     */
    updateGuideStatus(setShowFirstGuide, {
      type_id: typeIdObj.intelligence,
      button_id: dbiBtnLogMes.topchartMobileGameActiveUserTableTip.buttonId,
    });

    /**
     * @description 更新下载按钮气泡提示的漫游状态
     */
    updateGuideStatus(setShowFirstDownLoadBubble, {
      type_id: typeIdObj.intelligence,
      button_id: dbiBtnLogMes.topchartMobileGameActiveUserDownLoadTip.buttonId,
    });
  });

  return {
    showFirstGuide,
    showFirstDownLoadBubble,
    setShowFirstDownLoadBubble,
  };
}
